const AUTH = {};

AUTH.policyTypes = {
    signIn: {
        key: 'SIGN_IN',
    },
    resetPassword: {
        key: 'RESET_PASSWORD',
    },
    editProfile: {
        key: 'EDIT_PROFILE',
    },
};

export { AUTH };
